//缺1.4、蝴蝶
import makerjs from "makerjs";
// 矩形等去角 连线函数
function creatmyButterflyGap4(area, param) {
  console.log("是否调用此函数creatOneCorner（）");
  console.log("是否调用此函数creatOneCorner（）param=", param);
  var xa = param.xa, ya = param.ya, xb = param.xb, yb = param.yb, xc = param.xc, yc = param.yc,
  xd = param.xd, yd = param.yd, xf = param.xf, yf = param.yf, 
  xg = param.xg, yg = param.yg, xh = param.xh, yh = param.yh, xi = param.xi, yi = param.yi,
        x = param.x0, r1 = param.r1, r2 = param.r2, w = param.w, w1 = param.w1,h = param.h,
        glassH=param.glassH,glassW=param.glassW,cutLine=param.cutLine,cutFilletRadius=param.cutFilletRadius;
      var wd=(w1-w)/2,ly=Math.sqrt(r2*r2-wd*wd),lx=r2-wd;//确定两个圆弧坐标
      // var angleA = Math.asin(ly /r2)*180/Math.PI; //对边比斜边           
if(glassW*1>glassH * 1){
            console.log("长边在X轴￥￥￥￥￥");
            if (area == "A") {
                  var myButterflyGap4 = {
                        paths: {
                              Left: new makerjs.paths.Line([xa, ya], [xa, ya-h+ly]),
                              BottomLeft: new makerjs.paths.Arc([xa, ya-h+ly],[xa+lx, ya-h], r2, true,false),
                              Bottom: new makerjs.paths.Line([xa+lx, ya-h], [xa+w-lx, ya-h]),
                              BottomRight: new makerjs.paths.Arc([xa+w-lx, ya-h],[xa+w, ya-h+ly], r2, true,false),
                              Right: new makerjs.paths.Line([xa+w, ya-h+ly], [xa+w, ya]),
                        }
                  };
                  var myButterflyGap4WaterCut = {
                        paths: {
                              EnLine: new makerjs.paths.Line([xa, ya+cutLine], [xa, ya]),
                              Left: new makerjs.paths.Line([xa, ya], [xa, ya-h+ly]),
                              BottomLeft: new makerjs.paths.Arc([xa, ya-h+ly],[xa+lx, ya-h], r2, true,false),
                              Bottom: new makerjs.paths.Line([xa+lx, ya-h], [xa+w-lx, ya-h]),
                              BottomRight: new makerjs.paths.Arc([xa+w-lx, ya-h],[xa+w, ya-h+ly], r2, true,false),
                              Right: new makerjs.paths.Line([xa+w, ya-h+ly], [xa+w, ya]),
                              ExLine: new makerjs.paths.Line([xa+w, ya], [xa+w, ya+cutLine]),
                        }
                  };
                } else if (area == "B") {
                  var myButterflyGap4 = {
                    paths: {
                          Left: new makerjs.paths.Line([xb, yb], [xb, yb-h+ly]),
                          BottomLeft: new makerjs.paths.Arc([xb, yb-h+ly],[xb+lx, yb-h], r2, true,false),
                          Bottom: new makerjs.paths.Line([xb+lx, yb-h], [xb+w-lx, yb-h]),
                          BottomRight: new makerjs.paths.Arc([xb+w-lx, yb-h],[xb+w, yb-h+ly], r2, true,false),
                          Right: new makerjs.paths.Line([xb+w, yb-h+ly], [xb+w, yb]),
                    }
              };
              var myButterflyGap4WaterCut = {
                paths: {
                      EnLine: new makerjs.paths.Line([xb, yb+cutLine], [xb, yb]),
                      Left: new makerjs.paths.Line([xb, yb], [xb, yb-h+ly]),
                      BottomLeft: new makerjs.paths.Arc([xb, yb-h+ly],[xb+lx, yb-h], r2, true,false),
                      Bottom: new makerjs.paths.Line([xb+lx, yb-h], [xb+w-lx, yb-h]),
                      BottomRight: new makerjs.paths.Arc([xb+w-lx, yb-h],[xb+w, yb-h+ly], r2, true,false),
                      Right: new makerjs.paths.Line([xb+w, yb-h+ly], [xb+w, yb]),
                      ExLine: new makerjs.paths.Line([xb+w, yb], [xb+w, yb+cutLine]),
                }
          };
                } else if (area == "C") {
                  var myButterflyGap4 = {
                    paths: {
                          Left: new makerjs.paths.Line([xc-w, yc], [xc-w, yc-h+ly]),
                          BottomLeft: new makerjs.paths.Arc([xc-w, yc-h+ly],[xc-w+lx, yc-h], r2, true,false),
                          Bottom: new makerjs.paths.Line([xc-w+lx, yc-h], [xc-lx, yc-h]),
                          BottomRight: new makerjs.paths.Arc([xc-lx, yc-h],[xc, yc-h+ly], r2, true,false),
                          Right: new makerjs.paths.Line([xc, yc-h+ly], [xc, yc]),
                    }
              };
              var myButterflyGap4WaterCut = {
                paths: {
                      EnLine: new makerjs.paths.Line([xc-w, yc+cutLine], [xc-w, yc]),
                      Left: new makerjs.paths.Line([xc-w, yc], [xc-w, yc-h+ly]),
                      BottomLeft: new makerjs.paths.Arc([xc-w, yc-h+ly],[xc-w+lx, yc-h], r2, true,false),
                      Bottom: new makerjs.paths.Line([xc-w+lx, yc-h], [xc-lx, yc-h]),
                      BottomRight: new makerjs.paths.Arc([xc-lx, yc-h],[xc, yc-h+ly], r2, true,false),
                      Right: new makerjs.paths.Line([xc, yc-h+ly], [xc, yc]),
                      ExLine: new makerjs.paths.Line([xc, yc], [xc, yc+cutLine]),
                }
          };
                } else if (area == "G") {
                  var myButterflyGap4 = {
                    paths: {
                          Left: new makerjs.paths.Line([xg, yg], [xg, yg+h-ly]),
                          BottomLeft: new makerjs.paths.Arc([xg, yg+h-ly],[xg+lx, yg+h], r2, true,true),
                          Bottom: new makerjs.paths.Line([xg+lx, yg+h], [xg+w-lx, yg+h]),
                          BottomRight: new makerjs.paths.Arc([xg+w-lx, yg+h],[xg+w, yg+h-ly], r2, true,true),
                          Right: new makerjs.paths.Line([xg+w, yg+h-ly], [xg+w, yg]),
                    }
              };
              var myButterflyGap4WaterCut = {
                paths: {
                      EnLine: new makerjs.paths.Line([xg, yg-cutLine], [xg, yg]),
                      Left: new makerjs.paths.Line([xg, yg], [xg, yg+h-ly]),
                      BottomLeft: new makerjs.paths.Arc([xg, yg+h-ly],[xg+lx, yg+h], r2, true,true),
                      Bottom: new makerjs.paths.Line([xg+lx, yg+h], [xg+w-lx, yg+h]),
                      BottomRight: new makerjs.paths.Arc([xg+w-lx, yg+h],[xg+w, yg+h-ly], r2, true,true),
                      Right: new makerjs.paths.Line([xg+w, yg+h-ly], [xg+w, yg]),
                      ExLine: new makerjs.paths.Line([xg+w, yg], [xg+w, yg-cutLine]),
                }
          };
                } else if (area == "H") {
                  var myButterflyGap4 = {
                    paths: {
                          Left: new makerjs.paths.Line([xh, yh], [xh, yh+h-ly]),
                          BottomLeft: new makerjs.paths.Arc([xh, yh+h-ly],[xh+lx, yh+h], r2, true,true),
                          Bottom: new makerjs.paths.Line([xh+lx, yh+h], [xh+w-lx, yh+h]),
                          BottomRight: new makerjs.paths.Arc([xh+w-lx, yh+h],[xh+w, yh+h-ly], r2, true,true),
                          Right: new makerjs.paths.Line([xh+w, yh+h-ly], [xh+w, yh]),
                    }
              };
              var myButterflyGap4WaterCut = {
                paths: {
                      EnLine: new makerjs.paths.Line([xh, yh-cutLine], [xh, yh]),
                      Left: new makerjs.paths.Line([xh, yh], [xh, yh+h-ly]),
                      BottomLeft: new makerjs.paths.Arc([xh, yh+h-ly],[xh+lx, yh+h], r2, true,true),
                      Bottom: new makerjs.paths.Line([xh+lx, yh+h], [xh+w-lx, yh+h]),
                      BottomRight: new makerjs.paths.Arc([xh+w-lx, yh+h],[xh+w, yh+h-ly], r2, true,true),
                      Right: new makerjs.paths.Line([xh+w, yh+h-ly], [xh+w, yh]),
                      ExLine: new makerjs.paths.Line([xh+w, yh], [xh+w, yh-cutLine]),
                }
          };
                } else if (area == "I") {
                  var myButterflyGap4 = {
                    paths: {
                          Left: new makerjs.paths.Line([xi-w, yi], [xi-w, yi+h-ly]),
                          BottomLeft: new makerjs.paths.Arc([xi-w, yi+h-ly],[xi-w+lx, yi+h], r2, true,true),
                          Bottom: new makerjs.paths.Line([xi-w+lx, yi+h], [xi-lx, yi+h]),
                          BottomRight: new makerjs.paths.Arc([xi-lx, yi+h],[xi, yi+h-ly], r2, true,true),
                          Right: new makerjs.paths.Line([xi, yi+h-ly], [xi, yi]),
                    }
              };
              var myButterflyGap4WaterCut = {
                paths: {
                      EnLine: new makerjs.paths.Line([xi-w, yi-cutLine], [xi-w, yi]),
                      Left: new makerjs.paths.Line([xi-w, yi], [xi-w, yi+h-ly]),
                      BottomLeft: new makerjs.paths.Arc([xi-w, yi+h-ly],[xi-w+lx, yi+h], r2, true,true),
                      Bottom: new makerjs.paths.Line([xi-w+lx, yi+h], [xi-lx, yi+h]),
                      BottomRight: new makerjs.paths.Arc([xi-lx, yi+h],[xi, yi+h-ly], r2, true,true),
                      Right: new makerjs.paths.Line([xi, yi+h-ly], [xi, yi]),
                      ExLine: new makerjs.paths.Line([xi, yi], [xi, yi-cutLine]),
                }
          };
                }
}else{
  console.log("短边在X轴￥￥￥￥￥"); 
  if (area == "A") {
      var myButterflyGap4 = {
            paths: {
                  Left: new makerjs.paths.Line([xa, ya], [xa+h-ly, ya]),
                  BottomLeft: new makerjs.paths.Arc([xa+h-ly, ya],[xa+h, ya-lx], r2, true,true),
                  Bottom: new makerjs.paths.Line([xa+h, ya-lx], [xa+h, ya-w+lx]),
                  BottomRight: new makerjs.paths.Arc([xa+h, ya-w+lx],[xa+h-ly, ya-w], r2, true,true),
                  Right: new makerjs.paths.Line([xa+h-ly, ya-w], [xa, ya-w]),
            }
      };
      var myButterflyGap4WaterCut = {
            paths: {
                  EnLine: new makerjs.paths.Line([xa-cutLine, ya], [xa, ya]),
                  Left: new makerjs.paths.Line([xa, ya], [xa+h-ly, ya]),
                  BottomLeft: new makerjs.paths.Arc([xa+h-ly, ya],[xa+h, ya-lx], r2, true,true),
                  Bottom: new makerjs.paths.Line([xa+h, ya-lx], [xa+h, ya-w+lx]),
                  BottomRight: new makerjs.paths.Arc([xa+h, ya-w+lx],[xa+h-ly, ya-w], r2, true,true),
                  Right: new makerjs.paths.Line([xa+h-ly, ya-w], [xa, ya-w]),
                  ExLine: new makerjs.paths.Line([xa, ya-w], [xa-cutLine, ya-w]),
            }
      };
    } else if (area == "D") {
      var myButterflyGap4 = {
        paths: {
            Left: new makerjs.paths.Line([xd, yd+w/2], [xd+h-ly, yd+w/2]),
            BottomLeft: new makerjs.paths.Arc([xd+h-ly, yd+w/2],[xd+h, yd-lx+w/2], r2, true,true),
            Bottom: new makerjs.paths.Line([xd+h, yd-lx+w/2], [xd+h, yd-w/2+lx]),
            BottomRight: new makerjs.paths.Arc([xd+h, yd-w/2+lx],[xd+h-ly, yd-w/2], r2, true,true),
            Right: new makerjs.paths.Line([xd+h-ly, yd-w/2], [xd, yd-w/2]),
        }
  };
  var myButterflyGap4WaterCut = {
    paths: {
        EnLine: new makerjs.paths.Line([xd-cutLine, yd+w/2], [xd, yd+w/2]),
        Left: new makerjs.paths.Line([xd, yd+w/2], [xd+h-ly, yd+w/2]),
        BottomLeft: new makerjs.paths.Arc([xd+h-ly, yd+w/2],[xd+h, yd-lx+w/2], r2, true,true),
        Bottom: new makerjs.paths.Line([xd+h, yd-lx+w/2], [xd+h, yd-w/2+lx]),
        BottomRight: new makerjs.paths.Arc([xd+h, yd-w/2+lx],[xd+h-ly, yd-w/2], r2, true,true),
        Right: new makerjs.paths.Line([xd+h-ly, yd-w/2], [xd, yd-w/2]),
        ExLine: new makerjs.paths.Line([xd, yd-w/2], [xd-cutLine, yd-w/2]),
    }
};
    } else if (area == "G") {
      var myButterflyGap4 = {
        paths: {
            Left: new makerjs.paths.Line([xg, yg], [xg+h-ly, yg]),
            BottomLeft: new makerjs.paths.Arc([xg+h-ly, yg],[xg+h, yg+lx], r2, true,false),
            Bottom: new makerjs.paths.Line([xg+h, yg+lx], [xg+h, yg+w-lx]),
            BottomRight: new makerjs.paths.Arc([xg+h, yg+w-lx],[xg+h-ly, yg+w], r2, true,false),
            Right: new makerjs.paths.Line([xg+h-ly, yg+w], [xg, yg+w]),
        }
  };
  var myButterflyGap4WaterCut = {
    paths: {
        EnLine: new makerjs.paths.Line([xg-cutLine, yg], [xg, yg]),
        Left: new makerjs.paths.Line([xg, yg], [xg+h-ly, yg]),
        BottomLeft: new makerjs.paths.Arc([xg+h-ly, yg],[xg+h, yg+lx], r2, true,false),
        Bottom: new makerjs.paths.Line([xg+h, yg+lx], [xg+h, yg+w-lx]),
        BottomRight: new makerjs.paths.Arc([xg+h, yg+w-lx],[xg+h-ly, yg+w], r2, true,false),
        Right: new makerjs.paths.Line([xg+h-ly, yg+w], [xg, yg+w]),
        ExLine: new makerjs.paths.Line([xg, yg+w], [xg-cutLine, yg+w]),
    }
};
    } else if (area == "C") {
      var myButterflyGap4 = {
        paths: {
            Left: new makerjs.paths.Line([xc, yc], [xc-h+ly, yc]),
            BottomLeft: new makerjs.paths.Arc([xc-h+ly, yc],[xc-h, yc-lx], r2, true,false),
            Bottom: new makerjs.paths.Line([xc-h, yc-lx], [xc-h, yc-w+lx]),
            BottomRight: new makerjs.paths.Arc([xc-h, yc-w+lx],[xc-h+ly, yc-w], r2, true,false),
            Right: new makerjs.paths.Line([xc-h+ly, yc-w], [xc, yc-w]),
        }
  };
  var myButterflyGap4WaterCut = {
    paths: {
        EnLine: new makerjs.paths.Line([xc+cutLine, yc], [xc, yc]),
        Left: new makerjs.paths.Line([xc, yc], [xc-h+ly, yc]),
        BottomLeft: new makerjs.paths.Arc([xc-h+ly, yc],[xc-h, yc-lx], r2, true,false),
        Bottom: new makerjs.paths.Line([xc-h, yc-lx], [xc-h, yc-w+lx]),
        BottomRight: new makerjs.paths.Arc([xc-h, yc-w+lx],[xc-h+ly, yc-w], r2, true,false),
        Right: new makerjs.paths.Line([xc-h+ly, yc-w], [xc, yc-w]),
        ExLine: new makerjs.paths.Line([xc, yc-w], [xc+cutLine, yc-w]),
    }
};
    } else if (area == "F") {
      var myButterflyGap4 = {
        paths: {
            Left: new makerjs.paths.Line([xf, yf+w/2], [xf-h+ly, yf+w/2]),
            BottomLeft: new makerjs.paths.Arc([xf-h+ly, yf+w/2],[xf-h, yf-lx+w/2], r2, true,false),
            Bottom: new makerjs.paths.Line([xf-h, yf-lx+w/2], [xf-h, yf-w/2+lx]),
            BottomRight: new makerjs.paths.Arc([xf-h, yf-w/2+lx],[xf-h+ly, yf-w/2], r2, true,false),
            Right: new makerjs.paths.Line([xf-h+ly, yf-w/2], [xf, yf-w/2]),
        }
  };
  var myButterflyGap4WaterCut = {
    paths: {
        EnLine: new makerjs.paths.Line([xf+cutLine, yf+w/2], [xf, yf+w/2]),
        Left: new makerjs.paths.Line([xf, yf+w/2], [xf-h+ly, yf+w/2]),
        BottomLeft: new makerjs.paths.Arc([xf-h+ly, yf+w/2],[xf-h, yf-lx+w/2], r2, true,false),
        Bottom: new makerjs.paths.Line([xf-h, yf-lx+w/2], [xf-h, yf-w/2+lx]),
        BottomRight: new makerjs.paths.Arc([xf-h, yf-w/2+lx],[xf-h+ly, yf-w/2], r2, true,false),
        Right: new makerjs.paths.Line([xf-h+ly, yf-w/2], [xf, yf-w/2]),
        ExLine: new makerjs.paths.Line([xf, yf-w/2], [xf+cutLine, yf-w/2]),
    }
};
    } else if (area == "I") {
      var myButterflyGap4 = {
        paths: {
            Left: new makerjs.paths.Line([xi, yi], [xi-h+ly, yi]),
            BottomLeft: new makerjs.paths.Arc([xi-h+ly, yi],[xi-h, yi+lx], r2, true,true),
            Bottom: new makerjs.paths.Line([xi-h, yi+lx], [xi-h, yi+w-lx]),
            BottomRight: new makerjs.paths.Arc([xi-h, yi+w-lx],[xi-h+ly, yi+w], r2, true,true),
            Right: new makerjs.paths.Line([xi-h+ly, yi+w], [xi, yi+w]),
        }
  };
  var myButterflyGap4WaterCut = {
    paths: {
        EnLine: new makerjs.paths.Line([xi+cutLine, yi], [xi, yi]),
        Left: new makerjs.paths.Line([xi, yi], [xi-h+ly, yi]),
        BottomLeft: new makerjs.paths.Arc([xi-h+ly, yi],[xi-h, yi+lx], r2, true,true),
        Bottom: new makerjs.paths.Line([xi-h, yi+lx], [xi-h, yi+w-lx]),
        BottomRight: new makerjs.paths.Arc([xi-h, yi+w-lx],[xi-h+ly, yi+w], r2, true,true),
        Right: new makerjs.paths.Line([xi-h+ly, yi+w], [xi, yi+w]),
        ExLine: new makerjs.paths.Line([xi, yi+w], [xi+cutLine, yi+w]),
    }
};
    }
} 
  
var fillet1 = makerjs.path.fillet(myButterflyGap4.paths.Left, myButterflyGap4.paths.BottomLeft, r1);
var fillet2 = makerjs.path.fillet(myButterflyGap4.paths.BottomLeft, myButterflyGap4.paths.Bottom, r1);
var fillet3 = makerjs.path.fillet(myButterflyGap4.paths.Bottom, myButterflyGap4.paths.BottomRight, r1);
var fillet4 = makerjs.path.fillet(myButterflyGap4.paths.BottomRight, myButterflyGap4.paths.Right, r1);
myButterflyGap4.paths.fillet1 = fillet1;
myButterflyGap4.paths.fillet2 = fillet2;
myButterflyGap4.paths.fillet3 = fillet3;
myButterflyGap4.paths.fillet4 = fillet4;  
var fillet11 = makerjs.path.fillet(myButterflyGap4WaterCut.paths.Left, myButterflyGap4WaterCut.paths.BottomLeft, r1);
var fillet22 = makerjs.path.fillet(myButterflyGap4WaterCut.paths.BottomLeft, myButterflyGap4WaterCut.paths.Bottom, r1);
var fillet33 = makerjs.path.fillet(myButterflyGap4WaterCut.paths.Bottom, myButterflyGap4WaterCut.paths.BottomRight, r1);
var fillet44 = makerjs.path.fillet(myButterflyGap4WaterCut.paths.BottomRight, myButterflyGap4WaterCut.paths.Right, r1);
myButterflyGap4WaterCut.paths.fillet11 = fillet11;
myButterflyGap4WaterCut.paths.fillet22 = fillet22;
myButterflyGap4WaterCut.paths.fillet33 = fillet33;
myButterflyGap4WaterCut.paths.fillet44 = fillet44;
  return [myButterflyGap4,myButterflyGap4WaterCut];
};
// 矩形等去角标记 连线函数      
function creatmyButterflyGap4Mark(outParam, area, param, inputParam, fixedParam, OffsetParam, zoom) {
  console.log("是否调用此函数creatCornerMark()");
  console.log("是否调用此函数param", param);
  console.log("是否调用此函数outParam", outParam);
  console.log("是否调用此函数inputParam", inputParam);
  console.log("是否调用此函数OffsetParam", OffsetParam);
  var R1=inputParam.R1,R2=inputParam.R2,W=inputParam.W,W1=inputParam.W1,H=inputParam.H,X=inputParam.X,Y=inputParam.Y, myZoom = zoom * 1,
        glassW = outParam.glassW, glassH = outParam.glassH,
        xa = param.xa, ya = param.ya, xb = param.xb, yb = param.yb, xc = param.xc, yc = param.yc,
        xd = param.xd, yd = param.yd, xf = param.xf, yf = param.yf, 
         xg = param.xg, yg = param.yg, xh = param.xh, yh = param.yh, xi = param.xi, yi = param.yi,
        x = param.x0, r1 = param.r1, r2 = param.r2, w = param.w,w1 = param.w1,h = param.h, 
        wd=(w1-w)/2,ly=Math.sqrt(r2*r2-wd*wd),lx=r2-wd,
        markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
        markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,
        r1 = R1*1*myZoom,
              r2= R2*1*myZoom,
              h= H*1*myZoom,
              w = W*1*myZoom,
              w1 = W1*1*myZoom,
              dd=r2+wd,
                x0 = X*1*myZoom,
                y0 = Y*1*myZoom;
                if(r1!==0){
                 var TxtR1="R1="+R1;
                }
                if(r2!==0){
                 var TxtR2="R2="+R2;
                }
                if(h!==0){
                 var TxtH=H;
                }
                if(w!==0){
                 var TxtW=W;
                }
                if(w1!==0){
                 var TxtW1=W1;
                }
                if(y0!==0){          
                 var TxtY=Y;
                }
                if(x0!==0){          
                 var TxtX=X;
                }
if(glassW*1>glassH * 1){
  console.log("长边在X轴￥￥￥￥￥");
  if (area == "A") {
      var myBfg4GapAMakerW = {
            paths: {
                  "WALine0": new makerjs.paths.Line([xa,ya], [xa,ya+markShiftFour]),
                  "WALine1": new makerjs.paths.Line([xa+w,ya], [xa+w,ya+markShiftFour]),
                  "WALine2": new makerjs.paths.Line([xa,ya+markShiftTwo], [xa+w, ya+markShiftTwo]),
            }
      };
      var myBfg4GapAMakerW1 = {
            paths: {
                  "WA1Line0": new makerjs.paths.Line([xa-wd,ya-h-r2], [xa-wd,ya-h-r2-markShiftFour]),
                  "WA1Line1": new makerjs.paths.Line([xa+w1-wd,ya-h-r2], [xa+w1-wd,ya-h-r2-markShiftFour]),
                  "WA1Line2": new makerjs.paths.Line([xa-wd,ya-h-r2-markShiftTwo], [xa+w1-wd, ya-h-r2-markShiftTwo]),
            }
      };
     var myBfg4GapAMakerH = {
           paths: {
                 "HALine0": new makerjs.paths.Line([xa - markShift, ya], [xa - markShift, ya - h]),
                 "HALine2": new makerjs.paths.Line([xa - markShiftFour, ya - h], [xa, ya - h]),
           }
     };
        var myBfg4GapAMakerX = {
              paths: {
                    "XALine0": new makerjs.paths.Line([xa - x0, ya + markShift], [xa, ya + markShift]),
                    "XALine1": new makerjs.paths.Line([xa - x0, ya], [xa - x0, ya + markShiftFour]),
                    "XALine2": new makerjs.paths.Line([xa, ya], [xa, ya + markShiftFour]),
              }
        };
        var myBfg4GapAMakerR1 = {
              paths: {
                    "R1ALine0": new makerjs.paths.Line([xa, ya - h+ly+r1], [xa - dd - markHolesOneD, ya - h+ly+r1 - dd - markHolesOneD]),
              }
        };
        var myBfg4GapAMakerR2 = {
              paths: {
                    "R2ALine0": new makerjs.paths.Line([xa + w, ya - h], [xa + w + dd + markHolesOneD, ya - h - dd - markHolesOneD]),
              }
        };
        makerjs.model.addCaption(myBfg4GapAMakerW, TxtW,[xa,ya+markShiftFour], [xa+w, ya+markShiftFour]);//W文字标注
        makerjs.model.addCaption(myBfg4GapAMakerW1, TxtW1,[xa-wd,ya-h-r2-markShiftFour], [xa+w1-wd, ya-h-r2-markShiftFour]);//W1文字标注
        makerjs.model.addCaption(myBfg4GapAMakerH, TxtH, [xa - markShiftThree, ya - h], [xa - markShiftThree, ya]);//H文字标注
        makerjs.model.addCaption(myBfg4GapAMakerX, TxtX, [xa - x0, ya + markShiftTwo], [xa, ya + markShiftTwo]);//X文字标注
        makerjs.model.addCaption(myBfg4GapAMakerR1, TxtR1, [xa - dd - markHolesOneD-markShiftTwo*2, ya - h+ly - dd - markHolesOneD-markShift], [xa - dd - markHolesOneD, ya - h+ly - dd - markHolesOneD-markShift]);//R1文字标注
        makerjs.model.addCaption(myBfg4GapAMakerR2, TxtR2, [xa + w + dd + markHolesOneD+markShiftTwo, ya - h - dd - markHolesOneD], [xa + w + dd + markHolesOneD+markShiftFour*2, ya - h - dd - markHolesOneD]);//R2文字标注  
        var markers = [myBfg4GapAMakerW,myBfg4GapAMakerW1,myBfg4GapAMakerH,myBfg4GapAMakerX, myBfg4GapAMakerR1, myBfg4GapAMakerR2]
  } else if (area == "B") {
      var myBfg4GapBMakerW = {
        paths: {
              "WBLine0": new makerjs.paths.Line([xb,yb], [xb,yb+markShiftFour]),
              "WBLine1": new makerjs.paths.Line([xb+w,yb], [xb+w,yb+markShiftFour]),
              "WBLine2": new makerjs.paths.Line([xb,yb+markShiftTwo], [xb+w, yb+markShiftTwo]),
        }
  };
  var myBfg4GapBMakerW1 = {
    paths: {
          "W1BLine0": new makerjs.paths.Line([xb-wd,yb-h-r2], [xb-wd,yb-h-r2-markShiftFour]),
          "W1BLine1": new makerjs.paths.Line([xb+w1-wd,yb-h-r2], [xb+w1-wd,yb-h-r2-markShiftFour]),
          "W1BLine2": new makerjs.paths.Line([xb-wd,yb-h-r2-markShiftTwo], [xb+w1-wd, yb-h-r2-markShiftTwo]),
    }
};
var myBfg4GapBMakerH = {
      paths: {
            "HBLine0": new makerjs.paths.Line([xb - markShift, yb], [xb - markShift, yb - h]),
            "HBLine2": new makerjs.paths.Line([xb - markShiftFour, yb - h], [xb, yb - h]),
      }
};
   var myBfg4GapBMakerX = {
         paths: {
               "XBLine0": new makerjs.paths.Line([xb - x0, yb + markShift], [xb, yb + markShift]),
               "XBLine1": new makerjs.paths.Line([xb - x0, yb], [xb - x0, yb + markShiftFour]),
               "XBLine2": new makerjs.paths.Line([xb, yb], [xb, yb + markShiftFour]),
         }
   };
   var myBfg4GapBMakerR1 = {
         paths: {
               "R1BLine0": new makerjs.paths.Line([xb, yb - h+ly+r1], [xb - dd - markHolesOneD, yb - h+ly+r1 - dd - markHolesOneD]),
         }
   };
   var myBfg4GapBMakerR2 = {
         paths: {
               "R2BLine0": new makerjs.paths.Line([xb + w, yb - h], [xb + w + dd + markHolesOneD, yb - h - dd - markHolesOneD]),
         }
   };
   makerjs.model.addCaption(myBfg4GapBMakerW, TxtW,[xb,yb+markShiftFour], [xb+w, yb+markShiftFour]);//W文字标注
   makerjs.model.addCaption(myBfg4GapBMakerW1, TxtW1,[xb-wd,yb-h-r2-markShiftFour], [xb+w1-wd, yb-h-r2-markShiftFour]);//W1文字标注
   makerjs.model.addCaption(myBfg4GapBMakerH, TxtH, [xb - markShiftThree, yb - h], [xb - markShiftThree, yb]);//H文字标注
   makerjs.model.addCaption(myBfg4GapBMakerX, TxtX, [xb - x0, yb + markShiftTwo], [xb, yb + markShiftTwo]);//X文字标注
   makerjs.model.addCaption(myBfg4GapBMakerR1, TxtR1, [xb - dd - markHolesOneD-markShiftTwo*2, yb - h+ly - dd - markHolesOneD], [xb - dd - markHolesOneD, yb - h+ly - dd - markHolesOneD]);//R1文字标注
   makerjs.model.addCaption(myBfg4GapBMakerR2, TxtR2, [xb + w + dd + markHolesOneD, yb - h - dd - markHolesOneD], [xb + w + dd + markHolesOneD+markShiftTwo*2, yb - h - dd - markHolesOneD]);//R2文字标注  
   var markers = [myBfg4GapBMakerW,myBfg4GapBMakerW1,myBfg4GapBMakerH,myBfg4GapBMakerX, myBfg4GapBMakerR1, myBfg4GapBMakerR2]
  } else if (area == "C") {
      var myBfg4GapCMakerW = {
        paths: {
              "WCLine0": new makerjs.paths.Line([xc,yc], [xc,yc+markShiftFour]),
              "WCLine1": new makerjs.paths.Line([xc-w,yc], [xc-w,yc+markShiftFour]),
              "WCLine2": new makerjs.paths.Line([xc-w,yc+markShiftTwo], [xc, yc+markShiftTwo]),
        }
  };
  var myBfg4GapCMakerW1 = {
    paths: {
          "W1CLine0": new makerjs.paths.Line([xc+wd,yc-h-r2], [xc+wd,yc-h-r2-markShiftFour]),
          "W1CLine1": new makerjs.paths.Line([xc-w1+wd,yc-h-r2], [xc-w1+wd,yc-h-r2-markShiftFour]),
          "W1CLine2": new makerjs.paths.Line([xc-w1+wd,yc-h-r2-markShiftTwo], [xc+wd, yc-h-r2-markShiftTwo]),
    }
};
var myBfg4GapCMakerH = {
      paths: {
            "HCLine0": new makerjs.paths.Line([xc + markShift, yc], [xc + markShift, yc - h]),
            "HCLine2": new makerjs.paths.Line([xc + markShiftFour, yc - h], [xc, yc - h]),
      }
};

   var myBfg4GapCMakerX = {
         paths: {
               "XCLine0": new makerjs.paths.Line([xc+ x0, yc + markShift], [xc, yc + markShift]),
               "XCLine1": new makerjs.paths.Line([xc+ x0, yc], [xc+ x0, yc + markShiftFour]),
               "XCLine2": new makerjs.paths.Line([xc, yc], [xc, yc + markShiftFour]),
         }
   };
   var myBfg4GapCMakerR1 = {
         paths: {
               "R1CLine0": new makerjs.paths.Line([xc, yc - h+ly+r1], [xc + dd + markHolesOneD, yc - h+ly+r1 - dd - markHolesOneD]),
         }
   };
   var myBfg4GapCMakerR2 = {
         paths: {
               "R2CLine0": new makerjs.paths.Line([xc - w, yc - h], [xc - w - dd - markHolesOneD, yc - h - dd - markHolesOneD]),
         }
   };
   makerjs.model.addCaption(myBfg4GapCMakerW, TxtW,[xc-w,yc+markShiftThree], [xc, yc+markShiftThree]);//W文字标注
   makerjs.model.addCaption(myBfg4GapCMakerW1, TxtW1,[xc-w1+wd,yc-h-r2-markShiftThree], [xc+wd, yc-h-r2-markShiftThree]);//W1文字标注
   makerjs.model.addCaption(myBfg4GapCMakerH, TxtH, [xc + markShiftThree, yc - h], [xc + markShiftThree, yc]);//H文字标注
   makerjs.model.addCaption(myBfg4GapCMakerX, TxtX, [xc, yc + markShiftThree], [xc+ x0, yc + markShiftThree]);//X文字标注
   makerjs.model.addCaption(myBfg4GapCMakerR1, TxtR1, [xc + dd +markHolesOneD+markShift, yc - h+ly - dd - markHolesOneD], [xc + dd + markHolesOneD+markShiftFour*2, yc - h+ly - dd - markHolesOneD]);//R1文字标注
   makerjs.model.addCaption(myBfg4GapCMakerR2, TxtR2, [xc - w - dd - markHolesOneD-markShiftFour*2, yc - h - dd - markHolesOneD], [xc - w - dd - markHolesOneD, yc - h - dd - markHolesOneD]);//R2文字标注  
   var markers = [myBfg4GapCMakerW,myBfg4GapCMakerW1,myBfg4GapCMakerH,myBfg4GapCMakerX, myBfg4GapCMakerR1, myBfg4GapCMakerR2]
  } else if (area == "G") {
      var myBfg4GapGMakerW = {
        paths: {
              "WGLine0": new makerjs.paths.Line([xg,yg], [xg,yg-markShiftFour]),
              "WGLine1": new makerjs.paths.Line([xg+w,yg], [xg+w,yg-markShiftFour]),
              "WGLine2": new makerjs.paths.Line([xg,yg-markShiftTwo], [xg+w, yg-markShiftTwo]),
        }
  };
  var myBfg4GapGMakerW1 = {
    paths: {
          "W1GLine0": new makerjs.paths.Line([xg-wd,yg+h+r2], [xg-wd,yg+h+r2+markShiftFour]),
          "W1GLine1": new makerjs.paths.Line([xg+w1-wd,yg+h+r2], [xg+w1-wd,yg+h+r2+markShiftFour]),
          "W1GLine2": new makerjs.paths.Line([xg-wd,yg+h+r2+markShiftTwo], [xg+w1-wd, yg+h+r2+markShiftTwo]),
    }
};
var myBfg4GapGMakerH = {
      paths: {
            "HGLine0": new makerjs.paths.Line([xg - markShift, yg], [xg - markShift, yg + h]),
            "HGLine2": new makerjs.paths.Line([xg - markShiftFour, yg + h], [xg, yg + h]),
      }
};
   var myBfg4GapGMakerX = {
         paths: {
               "XGLine0": new makerjs.paths.Line([xg - x0, yg - markShiftTwo], [xg, yg - markShiftTwo]),
               "XGLine1": new makerjs.paths.Line([xg - x0, yg], [xg - x0, yg - markShiftFour]),
               "XGLine2": new makerjs.paths.Line([xg, yg], [xg, yg - markShiftFour]),
         }
   };
   var myBfg4GapGMakerR1 = {
         paths: {
               "R1GLine0": new makerjs.paths.Line([xg, yg + h-ly-r1], [xg - dd - markHolesOneD, yg + h-ly-r1 + dd + markHolesOneD]),
         }
   };
   var myBfg4GapGMakerR2 = {
         paths: {
               "R2GLine0": new makerjs.paths.Line([xg + w, yg + h], [xg + w + dd + markHolesOneD, yg + h + dd + markHolesOneD]),
         }
   };
   makerjs.model.addCaption(myBfg4GapGMakerW, TxtW,[xg,yg-markShiftFour], [xg+w, yg-markShiftFour]);//W文字标注
   makerjs.model.addCaption(myBfg4GapGMakerW1, TxtW1,[xg-wd,yg+h+r2+markShiftFour], [xg+w1-wd, yg+h+r2+markShiftFour]);//W1文字标注
   makerjs.model.addCaption(myBfg4GapGMakerH, TxtH, [xg - markShiftThree, yg + h], [xg - markShiftThree, yg]);//H文字标注
   makerjs.model.addCaption(myBfg4GapGMakerX, TxtX, [xg - x0, yg - markShiftFour], [xg, yg - markShiftFour]);//X文字标注
   makerjs.model.addCaption(myBfg4GapGMakerR1, TxtR1, [xg - dd - markHolesOneD-markShiftTwo*2, yg + h-ly-r1 + dd + markHolesOneD], [xg - dd - markHolesOneD, yg + h-ly-r1 + dd + markHolesOneD]);//R1文字标注
   makerjs.model.addCaption(myBfg4GapGMakerR2, TxtR2, [xg + w + dd + markHolesOneD, yg + h + dd + markHolesOneD], [xg + w + dd + markHolesOneD+markShiftTwo*2, yg + h + dd + markHolesOneD]);//R2文字标注  
   var markers = [myBfg4GapGMakerW,myBfg4GapGMakerW1,myBfg4GapGMakerH,myBfg4GapGMakerX, myBfg4GapGMakerR1, myBfg4GapGMakerR2]
  } else if (area == "H") {
      var myBfg4GapHMakerW = {
        paths: {
              "WHLine0": new makerjs.paths.Line([xh,yh], [xh,yh-markShiftFour*2]),
              "WHLine1": new makerjs.paths.Line([xh+w,yh], [xh+w,yh-markShiftFour*2]),
              "WHLine2": new makerjs.paths.Line([xh,yh-markShiftTwo*2], [xh+w, yh-markShiftTwo*2]),
        }
  };
  var myBfg4GapHMakerW1 = {
    paths: {
          "W1HLine0": new makerjs.paths.Line([xh-wd,yh+h+r2], [xh-wd,yh+h+r2+markShiftFour]),
          "W1HLine1": new makerjs.paths.Line([xh+w1-wd,yh+h+r2], [xh+w1-wd,yh+h+r2+markShiftFour]),
          "W1HLine2": new makerjs.paths.Line([xh-wd,yh+h+r2+markShiftTwo], [xh+w1-wd, yh+h+r2+markShiftTwo]),
    }
};
var myBfg4GapHMakerH = {
      paths: {
            "HHLine0": new makerjs.paths.Line([xh - markShift, yh], [xh - markShift, yh + h]),
            "HHLine2": new makerjs.paths.Line([xh - markShiftFour, yh + h], [xh, yh + h]),
      }
};
   var myBfg4GapHMakerX = {
         paths: {
              //  "XHLine0": new makerjs.paths.Line([xh - x0, yh - markShiftTwo], [xh, yh - markShiftTwo]),
              //  "XHLine1": new makerjs.paths.Line([xh - x0, yh], [xh - x0, yh - markShiftFour]),
              //  "XHLine2": new makerjs.paths.Line([xh, yh], [xh, yh - markShiftFour]),
         }
   };
   var myBfg4GapHMakerR1 = {
         paths: {
               "R1HLine0": new makerjs.paths.Line([xh, yh + h-ly-r1], [xh - dd - markHolesOneD, yh + h-ly-r1 + dd + markHolesOneD]),
         }
   };
   var myBfg4GapHMakerR2 = {
         paths: {
               "R2HLine0": new makerjs.paths.Line([xh + w, yh + h], [xh + w + dd + markHolesOneD, yh + h + dd + markHolesOneD]),
         }
   };
   makerjs.model.addCaption(myBfg4GapHMakerW, TxtW,[xh,yh-markShiftThree*2], [xh+w, yh-markShiftThree*2]);//W文字标注
   makerjs.model.addCaption(myBfg4GapHMakerW1, TxtW1,[xh-wd,yh+h+r2+markShiftFour], [xh+w1-wd, yh+h+r2+markShiftFour]);//W1文字标注
   makerjs.model.addCaption(myBfg4GapHMakerH, TxtH, [xh - markShiftThree, yh + h], [xh - markShiftThree, yh]);//H文字标注
   makerjs.model.addCaption(myBfg4GapHMakerX, TxtX, [xh - x0, yh + markShiftTwo], [xh, yh + markShiftTwo]);//X文字标注
   makerjs.model.addCaption(myBfg4GapHMakerR1, TxtR1, [xh - dd - markHolesOneD-markShiftTwo*2, yh+ h-ly-r1 + dd + markHolesOneD], [xh - dd - markHolesOneD, yh + h-ly-r1 + dd + markHolesOneD]);//R1文字标注
   makerjs.model.addCaption(myBfg4GapHMakerR2, TxtR2, [xh + w + dd + markHolesOneD, yh + h + dd + markHolesOneD], [xh + w + dd + markHolesOneD+markShiftTwo*2, yh + h + dd +markHolesOneD]);//R2文字标注  
   var markers = [myBfg4GapHMakerW,myBfg4GapHMakerW1,myBfg4GapHMakerH,myBfg4GapHMakerX, myBfg4GapHMakerR1, myBfg4GapHMakerR2]
  } else if (area == "I") {
      var myBfg4GapIMakerW = {
        paths: {
              "WILine0": new makerjs.paths.Line([xi,yi], [xi,yi-markShiftFour]),
              "WILine1": new makerjs.paths.Line([xi-w,yi], [xi-w,yi-markShiftFour]),
              "WILine2": new makerjs.paths.Line([xi-w,yi-markShiftTwo], [xi, yi-markShiftTwo]),
        }
  };
  var myBfg4GapIMakerW1 = {
    paths: {
          "W1ILine0": new makerjs.paths.Line([xi+wd,yi+h+r2], [xi+wd,yi+h+r2+markShiftFour]),
          "W1ILine1": new makerjs.paths.Line([xi-w1+wd,yi+h+r2], [xi-w1+wd,yi+h+r2+markShiftFour]),
          "W1ILine2": new makerjs.paths.Line([xi-w1+wd,yi+h+r2+markShiftTwo], [xi+wd, yi+h+r2+markShiftTwo]),
    }
};
var myBfg4GapIMakerH = {
      paths: {
            "HILine0": new makerjs.paths.Line([xi + markShift, yi], [xi + markShift, yi+ h]),
            "HILine2": new makerjs.paths.Line([xi + markShiftFour, yi + h], [xi, yi + h]),
      }
};
   var myBfg4GapIMakerX = {
         paths: {
               "XILine0": new makerjs.paths.Line([xi+ x0, yi - markShiftTwo], [xi, yi - markShiftTwo]),
               "XILine1": new makerjs.paths.Line([xi+ x0, yi], [xi+ x0, yi - markShiftFour]),
               "XILine2": new makerjs.paths.Line([xi, yi], [xi, yi - markShiftFour]),
         }
   };
   var myBfg4GapIMakerR1 = {
         paths: {
               "R1ILine0": new makerjs.paths.Line([xi, yi + h-ly-r1], [xi + dd + markHolesOneD, yi + h-ly-r1 + dd + markHolesOneD]),
         }
   };
   var myBfg4GapIMakerR2 = {
         paths: {
               "R2ILine0": new makerjs.paths.Line([xi - w, yi+ h], [xi - w - dd - markHolesOneD, yi + h + dd + markHolesOneD]),
         }
   };
   makerjs.model.addCaption(myBfg4GapIMakerW, TxtW,[xi-w,yi-markShiftFour], [xi, yi-markShiftFour]);//W文字标注
   makerjs.model.addCaption(myBfg4GapIMakerW1, TxtW1, [xi-w1+wd, yi+h+r2+markShiftFour],[xi+wd,yi+h+r2+markShiftFour]);//W1文字标注
   makerjs.model.addCaption(myBfg4GapIMakerH, TxtH, [xi + markShiftThree, yi + h], [xi + markShiftThree, yi]);//H文字标注
   makerjs.model.addCaption(myBfg4GapIMakerX, TxtX, [xi, yi- markShiftFour], [xi+ x0, yi - markShiftFour]);//X文字标注
   makerjs.model.addCaption(myBfg4GapIMakerR1, TxtR1, [xi + dd + markHolesOneD, yi + h-ly-r1 + dd + markHolesOneD], [xi + dd +markHolesOneD+markShiftTwo*2, yi + h-ly-r1 + dd + markHolesOneD]);//R1文字标注
   makerjs.model.addCaption(myBfg4GapIMakerR2, TxtR2, [xi - w - dd - markHolesOneD-markShiftTwo*2, yi + h+ dd + markHolesOneD], [xi - w - dd - markHolesOneD, yi + h + dd + markHolesOneD]);//R2文字标注  
   var markers = [myBfg4GapIMakerW,myBfg4GapIMakerW1,myBfg4GapIMakerH,myBfg4GapIMakerX, myBfg4GapIMakerR1, myBfg4GapIMakerR2]
  }
}else{
 console.log("短边在X轴￥￥￥￥￥");
 if (area == "A") {
      var myBfg4GapAMakerW = {
            paths: {
                  "WALine0": new makerjs.paths.Line([xa-markShiftFour,ya], [xa,ya]),
                  "WALine1": new makerjs.paths.Line([xa,ya-w], [xa-markShiftFour,ya-w]),
                  "WALine2": new makerjs.paths.Line([xa-markShiftTwo,ya-w], [xa-markShiftTwo, ya]),
            }
      };
      var myBfg4GapAMakerW1 = {
            paths: {
                  "WA1Line0": new makerjs.paths.Line([xa+h+r2,ya+wd], [xa+h+r2+markShiftFour,ya+wd]),
                  "WA1Line1": new makerjs.paths.Line([xa+h+r2,ya+wd-w1], [xa+h+r2+markShiftFour,ya+wd-w1]),
                  "WA1Line2": new makerjs.paths.Line([xa+h+r2+markShiftTwo,ya+wd], [xa+h+r2+markShiftTwo,ya+wd-w1]),
            }
      };
     var myBfg4GapAMakerH = {
           paths: {
                 "HALine0": new makerjs.paths.Line([xa, ya+ markShift], [xa + h, ya + markShift]),
                 "HALine2": new makerjs.paths.Line([xa + h, ya], [xa + h, ya + markShiftFour+r2+lx]),
           }
     };
        var myBfg4GapAMakerY = {
              paths: {
                    "YALine0": new makerjs.paths.Line([xa - markShiftTwo, ya], [xa - markShiftTwo, ya + y0]),
                    "YALine1": new makerjs.paths.Line([xa - markShiftFour, ya + y0], [xa, ya + y0]),
                    "YALine2": new makerjs.paths.Line([xa - markShiftFour, ya], [xa, ya]),
              }
        };
        var myBfg4GapAMakerR1 = {
              paths: {
                    "R1ALine0": new makerjs.paths.Line([xa+h, ya-w+lx], [xa+h+dd+markHolesOneD+markShiftThree, ya-w+lx+dd+markHolesOneD+markShiftThree]),
              }
        };
        var myBfg4GapAMakerR2 = {
              paths: {
                    "R2ALine0": new makerjs.paths.Line([xa + h, ya - w-wd], [xa + h+r2+markHolesOneD, ya - w-wd-r2-markHolesOneD]),
              }
        };
        makerjs.model.addCaption(myBfg4GapAMakerW, TxtW,[xa-markShiftFour,ya-w], [xa-markShiftFour, ya]);//W文字标注
        makerjs.model.addCaption(myBfg4GapAMakerW1, TxtW1,[xa+h+r2+markShiftFour,ya+wd-w1], [xa+h+r2+markShiftFour,ya+wd]);//W1文字标注
        makerjs.model.addCaption(myBfg4GapAMakerH, TxtH, [xa, ya+ markShiftThree], [xa + h, ya + markShiftThree]);//H文字标注
        makerjs.model.addCaption(myBfg4GapAMakerY, TxtY, [xa - markShiftFour, ya], [xa - markShiftFour, ya + y0]);//Y文字标注
        makerjs.model.addCaption(myBfg4GapAMakerR1, TxtR1, [xa+h+dd+markHolesOneD+markShift+markShiftThree, ya-w+lx+dd+markHolesOneD+markShiftThree], [xa+h+dd+markHolesOneD+markShift+markShiftThree+markShiftFour, ya-w+lx+dd+markHolesOneD+markShiftThree]);//R1文字标注
        makerjs.model.addCaption(myBfg4GapAMakerR2, TxtR2, [xa + h+r2+markHolesOneD+markShift, ya - w-wd-r2-markHolesOneD], [xa + h+r2+markHolesOneD+markShift+markShiftFour, ya - w-wd-r2-markHolesOneD]);//R2文字标注  
        var markers = [myBfg4GapAMakerW,myBfg4GapAMakerW1,myBfg4GapAMakerH,myBfg4GapAMakerY, myBfg4GapAMakerR1, myBfg4GapAMakerR2]
  } else if (area == "D") {
      var myBfg4GapDMakerW = {
            paths: {
                  // "WDLine0": new makerjs.paths.Line([xd-markShiftFour,yd+w/2], [xd,yd+w/2]),
                  // "WDLine1": new makerjs.paths.Line([xd,yd-w/2], [xd-markShiftFour,yd-w/2]),
                  "WDLine2": new makerjs.paths.Line([xd+markShift,yd-w/2], [xd+markShift, yd+w/2]),
            }
      };
      var myBfg4GapDMakerW1 = {
            paths: {
                  "WD1Line0": new makerjs.paths.Line([xd+h+r2,yd+wd+w/2], [xd+h+r2+markShiftFour,yd+wd+w/2]),
                  "WD1Line1": new makerjs.paths.Line([xd+h+r2,yd+wd-w1+w/2], [xd+h+r2+markShiftFour,yd+wd-w1+w/2]),
                  "WD1Line2": new makerjs.paths.Line([xd+h+r2+markShiftTwo,yd+wd+w/2], [xd+h+r2+markShiftTwo,yd+wd-w1+w/2]),
            }
      };
     var myBfg4GapDMakerH = {
           paths: {
                 "HDLine0": new makerjs.paths.Line([xd, yd+ markShift+w/2], [xd + h, yd + markShift+w/2]),
                 "HDLine2": new makerjs.paths.Line([xd + h, yd+w/2], [xd + h, yd + markShiftFour+r2+lx+w/2]),
           }
     };
        var myBfg4GapDMakerY = {
              paths: {
                    "YDLine0": new makerjs.paths.Line([xd - markShift, yd+w/2], [xd - markShift, yd + y0+w/2]),
                    "YDLine1": new makerjs.paths.Line([xd - markShiftFour, yd + y0+w/2], [xd, yd + y0+w/2]),
                    "YDLine2": new makerjs.paths.Line([xd - markShiftFour, yd+w/2], [xd, yd+w/2]),
              }
        };
        var myBfg4GapDMakerR1 = {
              paths: {
                    "R1DLine0": new makerjs.paths.Line([xd+h, yd-w/2+lx], [xd+h+dd+markHolesOneD+markShiftThree, yd-w/2+lx+dd+markHolesOneD+markShiftThree]),
              }
        };
        var myBfg4GapDMakerR2 = {
              paths: {
                    "R2DLine0": new makerjs.paths.Line([xd + h, yd - w/2-wd], [xd + h+r2+markHolesOneD, yd - w/2-wd-r2-markHolesOneD]),
              }
        };
        makerjs.model.addCaption(myBfg4GapDMakerW, TxtW,[xd+markShiftThree,yd-w/2], [xd+markShiftThree, yd+w/2]);//W文字标注
        makerjs.model.addCaption(myBfg4GapDMakerW1, TxtW1, [xd+h+r2+markShiftFour,yd+wd-w1+w/2],[xd+h+r2+markShiftFour,yd+wd+w/2]);//W1文字标注
        makerjs.model.addCaption(myBfg4GapDMakerH, TxtH, [xd, yd+ markShiftThree+w/2], [xd + h, yd + markShiftThree+w/2]);//H文字标注
        makerjs.model.addCaption(myBfg4GapDMakerY, TxtY, [xd - markShiftFour, yd+w/2], [xd - markShiftFour, yd + y0+w/2]);//Y文字标注
        makerjs.model.addCaption(myBfg4GapDMakerR1, TxtR1, [xd+h+dd+markHolesOneD+markShift+markShiftThree, yd-w/2+lx+dd+markHolesOneD+markShiftThree], [xd+h+dd+markHolesOneD+markShift+markShiftThree+markShiftFour, yd-w/2+lx+dd+markHolesOneD+markShiftThree]);//R1文字标注
        makerjs.model.addCaption(myBfg4GapDMakerR2, TxtR2, [xd + h+r2+markHolesOneD+markShift, yd - w/2-wd-r2-markHolesOneD], [xd + h+r2+markHolesOneD+markShift+markShiftFour, yd - w/2-wd-r2-markHolesOneD]);//R2文字标注  
        var markers = [myBfg4GapDMakerW,myBfg4GapDMakerW1,myBfg4GapDMakerH,myBfg4GapDMakerY, myBfg4GapDMakerR1, myBfg4GapDMakerR2]
  } else if (area == "C") {
      var myBfg4GapCMakerW = {
            paths: {
                  "WCLine0": new makerjs.paths.Line([xc+markShiftFour,yc], [xc,yc]),
                  "WCLine1": new makerjs.paths.Line([xc,yc-w], [xc+markShiftFour,yc-w]),
                  "WCLine2": new makerjs.paths.Line([xc+markShift,yc-w], [xc+markShift, yc]),
            }
      };
      var myBfg4GapCMakerW1 = {
            paths: {
                  "WC1Line0": new makerjs.paths.Line([xc-h-r2,yc+wd], [xc-h-r2-markShiftFour,yc+wd]),
                  "WC1Line1": new makerjs.paths.Line([xc-h-r2,yc+wd-w1], [xc-h-r2-markShiftFour,yc+wd-w1]),
                  "WC1Line2": new makerjs.paths.Line([xc-h-r2-markShiftTwo,yc+wd], [xc-h-r2-markShiftTwo,yc+wd-w1]),
            }
      };
     var myBfg4GapCMakerH = {
           paths: {
                 "HCLine0": new makerjs.paths.Line([xc, yc+ markShift], [xc - h, yc + markShift]),
                 "HCLine2": new makerjs.paths.Line([xc - h, yc], [xc - h, yc + markShiftFour+r2+lx]),
           }
     };
        var myBfg4GapCMakerY = {
              paths: {
                    "YCLine0": new makerjs.paths.Line([xc + markShift, yc], [xc + markShift, yc + y0]),
                    "YCLine1": new makerjs.paths.Line([xc + markShiftFour, yc + y0], [xc, yc + y0]),
                    "YCLine2": new makerjs.paths.Line([xc + markShiftFour, yc], [xc, yc]),
              }
        };
        var myBfg4GapCMakerR1 = {
              paths: {
                    "R1CLine0": new makerjs.paths.Line([xc-h, yc-w+lx], [xc-h-dd-markHolesOneD-markShiftThree, yc-w+lx+dd+markHolesOneD+markShiftThree]),
              }
        };
        var myBfg4GapCMakerR2 = {
              paths: {
                    "R2CLine0": new makerjs.paths.Line([xc - h, yc - w-wd], [xc- h-r2-markHolesOneD, yc - w-wd-r2-markHolesOneD]),
              }
        };
        makerjs.model.addCaption(myBfg4GapCMakerW, TxtW,[xc+markShiftFour,yc-w], [xc+markShiftFour, yc]);//W文字标注
        makerjs.model.addCaption(myBfg4GapCMakerW1, TxtW1, [xc-h-r2-markShiftFour,yc+wd-w1],[xc-h-r2-markShiftFour,yc+wd]);//W1文字标注
        makerjs.model.addCaption(myBfg4GapCMakerH, TxtH, [xc - h, yc+ markShiftThree], [xc, yc + markShiftThree]);//H文字标注
        makerjs.model.addCaption(myBfg4GapCMakerY, TxtY, [xc + markShiftFour, yc], [xc + markShiftFour, yc + y0]);//Y文字标注
        makerjs.model.addCaption(myBfg4GapCMakerR1, TxtR1, [xc-h-dd-markHolesOneD-markShift-markShiftThree-markShiftFour, yc-w+lx+dd+markHolesOneD+markShiftThree], [xc-h-dd-markHolesOneD-markShift-markShiftThree, yc-w+lx+dd+markHolesOneD+markShiftThree]);//R1文字标注
        makerjs.model.addCaption(myBfg4GapCMakerR2, TxtR2, [xc- h-r2-markHolesOneD-markShift-markShiftFour, yc - w-wd-r2-markHolesOneD], [xc - h-r2-markHolesOneD-markShift, yc - w-wd-r2-markHolesOneD]);//R2文字标注  
        var markers = [myBfg4GapCMakerW,myBfg4GapCMakerW1,myBfg4GapCMakerH,myBfg4GapCMakerY, myBfg4GapCMakerR1, myBfg4GapCMakerR2]
  } else if (area == "G") {
      var myBfg4GapGMakerW = {
            paths: {
                  "WGLine0": new makerjs.paths.Line([xg-markShiftFour,yg], [xg,yg]),
                  "WGLine1": new makerjs.paths.Line([xg,yg+w], [xg-markShiftFour,yg+w]),
                  "WGLine2": new makerjs.paths.Line([xg-markShiftTwo,yg+w], [xg-markShiftTwo, yg]),
            }
      };
      var myBfg4GapGMakerW1 = {
            paths: {
                  "WG1Line0": new makerjs.paths.Line([xg+h+r2,yg-wd], [xg+h+r2+markShiftFour,yg-wd]),
                  "WG1Line1": new makerjs.paths.Line([xg+h+r2,yg-wd+w1], [xg+h+r2+markShiftFour,yg-wd+w1]),
                  "WG1Line2": new makerjs.paths.Line([xg+h+r2+markShiftTwo,yg-wd], [xg+h+r2+markShiftTwo,yg-wd+w1]),
            }
      };
     var myBfg4GapGMakerH = {
           paths: {
                 "HGLine0": new makerjs.paths.Line([xg, yg- markShift], [xg + h, yg - markShift]),
                 "HGLine2": new makerjs.paths.Line([xg + h, yg], [xg + h, yg - markShiftFour-r2-lx]),
           }
     };
        var myBfg4GapGMakerY = {
              paths: {
                    "YGLine0": new makerjs.paths.Line([xg - markShiftTwo, yg], [xg - markShiftTwo, yg - y0]),
                    "YGLine1": new makerjs.paths.Line([xg - markShiftFour, yg - y0], [xg, yg - y0]),
                    "YGLine2": new makerjs.paths.Line([xg - markShiftFour, yg], [xg, yg]),
              }
        };
        var myBfg4GapGMakerR1 = {
              paths: {
                    "R1GLine0": new makerjs.paths.Line([xg+h, yg+w-lx], [xg+h+dd+markHolesOneD+markShiftThree, yg+w-lx-dd-markHolesOneD-markShiftThree]),
              }
        };
        var myBfg4GapGMakerR2 = {
              paths: {
                    "R2GLine0": new makerjs.paths.Line([xg + h, yg + w+wd], [xg + h+r2+markHolesOneD, yg + w+wd+r2+markHolesOneD]),
              }
        };
        makerjs.model.addCaption(myBfg4GapGMakerW, TxtW,[xg-markShiftFour,yg], [xg-markShiftFour, yg+w]);//W文字标注
        makerjs.model.addCaption(myBfg4GapGMakerW1, TxtW1,[xg+h+r2+markShiftFour,yg-wd], [xg+h+r2+markShiftFour,yg-wd+w1]);//W1文字标注
        makerjs.model.addCaption(myBfg4GapGMakerH, TxtH, [xg, yg- markShiftThree], [xg + h, yg - markShiftThree]);//H文字标注
        makerjs.model.addCaption(myBfg4GapGMakerY, TxtY, [xg - markShiftFour, yg - y0], [xg - markShiftFour, yg]);//Y文字标注
        makerjs.model.addCaption(myBfg4GapGMakerR1, TxtR1, [xg+h+dd+markHolesOneD+markShift+markShiftThree, yg+w-lx-dd-markHolesOneD-markShiftThree], [xg+h+dd+markHolesOneD+markShift+markShiftThree+markShiftFour, yg+w-lx-dd-markHolesOneD-markShiftThree]);//R1文字标注
        makerjs.model.addCaption(myBfg4GapGMakerR2, TxtR2, [xg + h+r2+markHolesOneD+markShift, yg + w+wd+r2+markHolesOneD], [xg + h+r2+markHolesOneD+markShift+markShiftFour, yg + w+wd+r2+markHolesOneD]);//R2文字标注  
        var markers = [myBfg4GapGMakerW,myBfg4GapGMakerW1,myBfg4GapGMakerH,myBfg4GapGMakerY, myBfg4GapGMakerR1, myBfg4GapGMakerR2]
  } else if (area == "F") {
      var myBfg4GapFMakerW = {
            paths: {
                  // "WFLine0": new makerjs.paths.Line([xd-markShiftFour,yd+w/2], [xd,yd+w/2]),
                  // "WFLine1": new makerjs.paths.Line([xd,yd-w/2], [xd-markShiftFour,yd-w/2]),
                  "WFLine2": new makerjs.paths.Line([xf-markShift,yf-w/2], [xf-markShift, yf+w/2]),
            }
      };
      var myBfg4GapFMakerW1 = {
            paths: {
                  "WF1Line0": new makerjs.paths.Line([xf-h-r2,yf+wd+w/2], [xf-h-r2-markShiftFour,yf+wd+w/2]),
                  "WF1Line1": new makerjs.paths.Line([xf-h-r2,yf+wd-w1+w/2], [xf-h-r2-markShiftFour,yf+wd-w1+w/2]),
                  "WF1Line2": new makerjs.paths.Line([xf-h-r2-markShiftTwo,yf+wd+w/2], [xf-h-r2-markShiftTwo,yf+wd-w1+w/2]),
            }
      };
     var myBfg4GapFMakerH = {
           paths: {
                 "HFLine0": new makerjs.paths.Line([xf, yf+ markShift+w/2], [xf - h, yf + markShift+w/2]),
                 "HFLine2": new makerjs.paths.Line([xf - h, yf+w/2], [xf - h, yf + markShiftFour+r2+lx+w/2]),
           }
     };
        var myBfg4GapFMakerY = {
              paths: {
                    "YFLine0": new makerjs.paths.Line([xf + markShift, yf+w/2], [xf + markShift, yf + y0+w/2]),
                    "YFLine1": new makerjs.paths.Line([xf + markShiftFour, yf + y0+w/2], [xf, yf + y0+w/2]),
                    "YFLine2": new makerjs.paths.Line([xf + markShiftFour, yf+w/2], [xf, yf+w/2]),
              }
        };
        var myBfg4GapFMakerR1 = {
              paths: {
                    "R1FLine0": new makerjs.paths.Line([xf-h, yf-w/2+lx], [xf-h-dd-markHolesOneD-markShiftThree, yf-w/2+lx+dd+markHolesOneD+markShiftThree]),
              }
        };
        var myBfg4GapFMakerR2 = {
              paths: {
                    "R2FLine0": new makerjs.paths.Line([xf - h, yf - w/2-wd], [xf - h-r2-markHolesOneD, yf - w/2-wd-r2-markHolesOneD]),
              }
        };
        makerjs.model.addCaption(myBfg4GapFMakerW, TxtW,[xf-markShiftThree,yf-w/2], [xf-markShiftThree, yf+w/2]);//W文字标注
        makerjs.model.addCaption(myBfg4GapFMakerW1, TxtW1, [xf-h-r2-markShiftFour,yf+wd-w1+w/2],[xf-h-r2-markShiftFour,yf+wd+w/2]);//W1文字标注
        makerjs.model.addCaption(myBfg4GapFMakerH, TxtH, [xf - h, yf+ markShiftThree+w/2], [xf, yf + markShiftThree+w/2]);//H文字标注
        makerjs.model.addCaption(myBfg4GapFMakerY, TxtY, [xf + markShiftFour, yf+w/2], [xf + markShiftFour, yf + y0+w/2]);//Y文字标注
        makerjs.model.addCaption(myBfg4GapFMakerR1, TxtR1, [xf-h-dd-markHolesOneD-markShift-markShiftThree-markShiftFour, yf-w/2+lx+dd+markHolesOneD+markShiftThree], [xf-h-dd-markHolesOneD-markShift-markShiftThree, yf-w/2+lx+dd+markHolesOneD+markShiftThree]);//R1文字标注
        makerjs.model.addCaption(myBfg4GapFMakerR2, TxtR2, [xf - h-r2-markHolesOneD-markShift-markShiftFour, yf - w/2-wd-r2-markHolesOneD], [xf - h-r2-markHolesOneD-markShift, yf - w/2-wd-r2-markHolesOneD]);//R2文字标注  
        var markers = [myBfg4GapFMakerW,myBfg4GapFMakerW1,myBfg4GapFMakerH,myBfg4GapFMakerY, myBfg4GapFMakerR1, myBfg4GapFMakerR2]
  } else if (area == "I") {
      var myBfg4GapIMakerW = {
            paths: {
                  "WILine0": new makerjs.paths.Line([xi+markShiftFour,yi], [xi,yi]),
                  "WILine1": new makerjs.paths.Line([xi,yi+w], [xi+markShiftFour,yi+w]),
                  "WILine2": new makerjs.paths.Line([xi+markShift,yi+w], [xi+markShift, yi]),
            }
      };
      var myBfg4GapIMakerW1 = {
            paths: {
                  "WI1Line0": new makerjs.paths.Line([xi-h-r2,yi-wd], [xi-h-r2-markShiftFour,yi-wd]),
                  "WI1Line1": new makerjs.paths.Line([xi-h-r2,yi-wd+w1], [xi-h-r2-markShiftFour,yi-wd+w1]),
                  "WI1Line2": new makerjs.paths.Line([xi-h-r2-markShiftTwo,yi-wd], [xi-h-r2-markShiftTwo,yi-wd+w1]),
            }
      };
     var myBfg4GapIMakerH = {
           paths: {
                 "HILine0": new makerjs.paths.Line([xi, yi- markShift], [xi - h, yi - markShift]),
                 "HILine2": new makerjs.paths.Line([xi - h, yi], [xi - h, yi -markShiftFour-r2-lx]),
           }
     };
        var myBfg4GapIMakerY = {
              paths: {
                    "YILine0": new makerjs.paths.Line([xi + markShift, yi], [xi + markShift, yi - y0]),
                    "YILine1": new makerjs.paths.Line([xi + markShiftFour, yi - y0], [xi, yi - y0]),
                    "YILine2": new makerjs.paths.Line([xi + markShiftFour, yi], [xi, yi]),
              }
        };
        var myBfg4GapIMakerR1 = {
              paths: {
                    "R1ILine0": new makerjs.paths.Line([xi-h, yi+w-lx], [xi-h-dd-markHolesOneD-markShiftThree, yi+w-lx-dd-markHolesOneD-markShiftThree]),
              }
        };
        var myBfg4GapIMakerR2 = {
              paths: {
                    "R2ILine0": new makerjs.paths.Line([xi - h, yi + w+wd], [xi- h-r2-markHolesOneD, yi+ w+wd+r2+markHolesOneD]),
              }
        };
        makerjs.model.addCaption(myBfg4GapIMakerW, TxtW,[xi+markShiftFour,yi], [xi+markShiftFour, yi+w]);//W文字标注
        makerjs.model.addCaption(myBfg4GapIMakerW1, TxtW1, [xi-h-r2-markShiftFour,yi-wd],[xi-h-r2-markShiftFour,yi-wd+w1]);//W1文字标注
        makerjs.model.addCaption(myBfg4GapIMakerH, TxtH, [xi - h, yi- markShiftThree], [xi, yi - markShiftThree]);//H文字标注
        makerjs.model.addCaption(myBfg4GapIMakerY, TxtY, [xi + markShiftFour, yi - y0], [xi + markShiftFour, yi]);//Y文字标注
        makerjs.model.addCaption(myBfg4GapIMakerR1, TxtR1, [xi-h-dd-markHolesOneD-markShift-markShiftThree-markShiftFour, yi+w-lx-dd-markHolesOneD-markShiftThree], [xi-h-dd-markHolesOneD-markShift-markShiftThree, yi+w-lx-dd-markHolesOneD-markShiftThree]);//R1文字标注
        makerjs.model.addCaption(myBfg4GapIMakerR2, TxtR2, [xi- h-r2-markHolesOneD-markShift-markShiftFour, yi+w+wd+r2+markHolesOneD], [xi - h-r2-markHolesOneD-markShift, yi+ w+wd+r2+markHolesOneD]);//R2文字标注  
        var markers = [myBfg4GapIMakerW,myBfg4GapIMakerW1,myBfg4GapIMakerH,myBfg4GapIMakerY, myBfg4GapIMakerR1, myBfg4GapIMakerR2]
  }
}
  
  console.log("markers||||||||||||||||||=", markers)
  return markers;
};
// inputParam,model,myHolesNum,outParam,fixedParam
// (D,X,Y,area,plate,markers,myHolesNum,glassW,glassH,markShift,markShiftTwo,markShiftThree,markShiftFour,markHolesOneD)
function ButterflyGap4(inputParam, model, myHolesNum, outParam, fixedParam, zoom, θCut, rCut,cutLine,cutFilletRadius){
  var frame = outParam.shapeName;
  console.log("outParam==", outParam)
  console.log("model==", model)
  console.log("inputParam==", inputParam)
  console.log("outParam.shapeName==////////", outParam.shapeName)
  if (typeof (frame) == "undefined") {
        var R1=inputParam.R1,R2=inputParam.R2,W=inputParam.W,W1=inputParam.W1,H=inputParam.H,X=inputParam.X,Y=inputParam.Y,area=inputParam.area,myZoom=zoom*1, myθCut = θCut, myrCut = rCut,
        plate = model.plate, cutPlate = model.cutPlate, markers = model.markers, frame = "Rectangle",
              glassW = outParam.glassW, glassH = outParam.glassH,cutLine=cutLine*1,cutFilletRadius=cutFilletRadius*1,
              markShift = fixedParam.markShift, markShiftTwo = fixedParam.markShiftTwo,
              markShiftThree = fixedParam.markShiftThree, markShiftFour = fixedParam.markShiftFour, markHolesOneD = fixedParam.markHolesOneD,
              r1 = R1*1*myZoom,
              r2= R2*1*myZoom,
              h= H*1*myZoom,
              w = W*1*myZoom,
              w1 = W1*1*myZoom,
                x0 = X*1*myZoom,
                y0 = Y*1*myZoom;
                if(plate.models===undefined||plate.models===""){
                  console.log("1111111111111111");
                  plate.models={};
                          }        
                          if(cutPlate.models===undefined||cutPlate.models===""){
                              console.log("22222222222");
                              //cutPlate.models={};
                              cutPlate.models={};
                          }
                          if(markers.models===undefined||markers.models===""){            
                              console.log("333333333333");
                              markers.models={};
                          }
                if(r1!==0){
                 var TxtR1="R1="+R1;
                }
                if(r2!==0){
                 var TxtR2="R2="+R2;
                }
                if(h!==0){
                 var TxtH=H;
                }
                if(w!==0){
                 var TxtW=W;
                }
                if(w1!==0){
                 var TxtW1=W1;
                }
                if(y0!==0){          
                 var TxtY=Y;
                }
                if(x0!==0){          
                 var TxtX=X;
                }
  } else {
        var R1=inputParam.R1,R2=inputParam.R2,W=inputParam.W,W1=inputParam.W1,H=inputParam.H,X=inputParam.X,Y=inputParam.Y,area=inputParam.area,myZoom=zoom*1, myθCut = θCut, myrCut = rCut,
        plate = model.plate, cutPlate = model.cutPlate, markers = model.markers, frame = outParam.shapeName,
              glassW = outParam.glassW, glassH = outParam.glassH,cutLine=cutLine*1,cutFilletRadius=cutFilletRadius*1,
              markShift = fixedParam.markShift, markShiftTwo = fixedParam.markShiftTwo,
              markShiftThree = fixedParam.markShiftThree, markShiftFour = fixedParam.markShiftFour, markHolesOneD = fixedParam.markHolesOneD,
              r1 = R1*1*myZoom,
              r2= R2*1*myZoom,
              h= H*1*myZoom,
              w = W*1*myZoom,
              w1 = W1*1*myZoom,
                x0 = X*1*myZoom,
                y0 = Y*1*myZoom;
                if(plate.models===undefined||plate.models===""){
                  console.log("1111111111111111");
                  plate.models={};
                          }        
                          if(cutPlate.models===undefined||cutPlate.models===""){
                              console.log("22222222222");
                              //cutPlate.models={};
                              cutPlate.models={};
                          }
                          if(markers.models===undefined||markers.models===""){            
                              console.log("333333333333");
                              markers.models={};
                          }
                if(r1!==0){
                 var TxtR1="R1="+R1;
                }
                if(r2!==0){
                 var TxtR2="R2="+R2;
                }
                if(h!==0){
                 var TxtH=H;
                }
                if(w!==0){
                 var TxtW=W;
                }
                if(w1!==0){
                 var TxtW1=W1;
                }
                if(y0!==0){          
                 var TxtY=Y;
                }
                if(x0!==0){          
                 var TxtX=X;
                }
  }
  if (frame == "Rectangle") {
        console.log("frame==undefined||||*****")
        //在A区域 计算孔的位置       
        var xa = x0, ya = glassH * 1 - y0,
              //B区域//只有Y标注没有X标注 
              xb = glassW * 1 / 2, yb = glassH * 1 - y0,
              //C区域
              xc = glassW * 1 - x0, yc = glassH * 1 - y0,
              //在G区域 计算孔的位置
                  //D区域
  //只有X标注没有Y标注 
  xd=x0,yd=glassH * 1/2,
  //E区域
  //只有X标注没有Y标注 
  xe=glassW * 1/2,ye=glassH * 1/2,
  //F区域
  //只有X标注没有Y标注 
  xf=glassW * 1-x0,yf=glassH * 1/2,
              xg = x0, yg = y0,
              //在H区域 计算孔的位置
              //只标注Y
              xh = glassW * 1 / 2, yh = y0,
              //在I区域 计算孔的位置
              xi = glassW * 1 - x0, yi = y0;
        var OffsetParam = {};
  } else if (frame == "IsoscelesTrapezoid") {

  } else if (frame == "RightAngledTrapezoid") {

  } else if (frame == "OtherTrapezoidsA") {

  } else if (frame == "OtherTrapezoidsB") {

  } else if (frame == "ParallelogramA") {


  } else if (frame == "ParallelogramB") {

  }
  // 坐标参数
  var paramCoordinate = { x0,r1,cutLine,cutFilletRadius,r2,h,w,w1,xa, ya, xb, yb, xd, yd, xf, yf, xc, yc, xg, yg, xh, yh, xi, yi,glassW,glassH};
  const allKeys = Object.getOwnPropertyNames(JSON.parse(JSON.stringify(model.plate.models)));
  var areaPoint = "";
  console.log("//角7、地弹簧3 ------", allKeys)
  if (allKeys[0] == frame) {
        allKeys.shift();//去掉数组第一个元素
  }
  console.log("//角7、地弹簧3 位置去掉数组第一个元素------", allKeys)
  switch (area) {
        case "1": areaPoint = "A"; break;
        case "2": areaPoint = "B"; break;
        case "3": areaPoint = "C"; break;
        case "4": areaPoint = "D"; break;
        case "6": areaPoint = "F"; break;
        case "7": areaPoint = "G"; break;
        case "8": areaPoint = "H"; break;
        case "9": areaPoint = "I"; break;
  }
  /**
  * 画图
  * 
  */
  var ObjName = "myButterflyGap4" + areaPoint;
  var ObjNameMmyButterflyGap = "myButterflyGap4" + areaPoint + "Mark";//角标记
  var ObjNameMmyButterflyGap = "myButterflyGap4" + areaPoint + "Mark";//角标记
  ObjName = creatmyButterflyGap4(areaPoint, paramCoordinate);//图形
  console.log("ObjName===|||||||||", ObjName);
  ObjNameMmyButterflyGap = creatmyButterflyGap4Mark(outParam, areaPoint, paramCoordinate, inputParam, fixedParam, OffsetParam, zoom);//图形
  console.log("ObjNameMmyButterflyGap===|||||||||角标注", ObjNameMmyButterflyGap);
  console.log("cutPlate.models====************", cutPlate.models),
        console.log("plate.models====**************", plate.models),
        console.log("markers.models====*************", markers.models),
     //    myBfg4GapAMakerW,myBfg4GapAMakerH,myBfg4GapAMakerH1,myBfg4GapAMakerH2,myBfg4GapAMakerX, myBfg4GapAMakerR1, myBfg4GapAMakerR2
        cutPlate.models["TypeGapes_myButterflyGap4" + areaPoint + myHolesNum] = ObjName[1];
  plate.models["TypeGapes_myButterflyGap4" + areaPoint + myHolesNum] = ObjName[1];
  markers.models["TypeGapes_myButterflyGap4" + areaPoint + myHolesNum] = ObjName[1];
  markers.models["TypeGapes_myButterflyGap4W" + areaPoint + myHolesNum + "Mark"] = ObjNameMmyButterflyGap[0];
  markers.models["TypeGapes_myButterflyGap4W1" + areaPoint + myHolesNum + "Mark"] = ObjNameMmyButterflyGap[1];
  markers.models["TypeGapes_myButterflyGap4H" + areaPoint + myHolesNum + "Mark"] = ObjNameMmyButterflyGap[2];
  markers.models["TypeGapes_myButterflyGap4X" + areaPoint + myHolesNum + "Mark"] = ObjNameMmyButterflyGap[3];
  markers.models["TypeGapes_myButterflyGap4R1" + areaPoint + myHolesNum + "Mark"] = ObjNameMmyButterflyGap[4];
  markers.models["TypeGapes_myButterflyGap4R2" + areaPoint + myHolesNum + "Mark"] = ObjNameMmyButterflyGap[5];

myHolesNum++;
return{plate,cutPlate,markers, myHolesNum}
};
export default ButterflyGap4;